import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const socket = io("http://172.104.206.4:5000"); // change port

export default function User() {
  const localVideo = useRef();
  const remoteVideo = useRef();
  const pcRef = useRef(null);
  const [expertId, setExpertId] = useState("");

  const myId = "69301a1aea2bd209bd069297";

  useEffect(() => {
    socket.emit("register", { userId: myId, role: "user" });

    socket.on("callAnswer", async ({ answer }) => {
      if (!pcRef.current) return;
      await pcRef.current.setRemoteDescription(answer);
    });

    socket.on("callCandidate", async ({ candidate }) => {
      if (pcRef.current) await pcRef.current.addIceCandidate(candidate);
    });

    socket.on("endCallExpertUser", ({ endedBy }) => {
      if (pcRef.current) {
        pcRef.current.close();
        pcRef.current = null;
      }
      if (localVideo.current?.srcObject) {
        localVideo.current.srcObject.getTracks().forEach(track => track.stop());
      }
      alert("Call ended by " + endedBy);
    });

    return () => socket.off();
  }, []);

  const createPeerConnection = (stream) => {
    pcRef.current = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
    });

    stream.getTracks().forEach(track => pcRef.current.addTrack(track, stream));

    pcRef.current.ontrack = e => {
      remoteVideo.current.srcObject = e.streams[0];
    };

    pcRef.current.onicecandidate = e => {
      if (e.candidate) socket.emit("callCandidate", { candidate: e.candidate, to: expertId });
    };
  };

  const callExpert = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    localVideo.current.srcObject = stream;

    createPeerConnection(stream);

    socket.emit("userCallExpert", { fromUser: myId, toExpert: expertId });

    const offer = await pcRef.current.createOffer();
    await pcRef.current.setLocalDescription(offer);
    socket.emit("callOffer", { offer, to: expertId });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h2>User Panel</h2>
      <video ref={localVideo} autoPlay muted playsInline width="250" />
      <video ref={remoteVideo} autoPlay playsInline width="250" />
      <br /><br />
      <input
        placeholder="Expert ID"
        value={expertId}
        onChange={e => setExpertId(e.target.value)}
      />
      <button onClick={callExpert}>📞 Call Expert</button>
    </div>
  );
}
